import { TechDocsIndexPage } from '@backstage/plugin-techdocs';
import techDocsPlugin from '@backstage/plugin-techdocs/alpha';

export const techDocsPluginOverride = techDocsPlugin.withOverrides({
  extensions: [
    techDocsPlugin.getExtension('page:techdocs').override({
      params: {
        path: '/docs',
        noHeader: true,
        loader: async () => (
          <TechDocsIndexPage />
        ),
      },
    }),
  ],
});